<template>
  <div class="ui-ai-conversation-error">
    <div class="ui-ai-conversation-error__message">
      {{ message }}
    </div>
    <UIButton
      v-if="!hideButton"
      label="Retry"
      variant="secondary"
      size="sm"
      :leading="ArrowPathIcon"
      @click="handleClickRetry"
    />
  </div>
</template>

<script setup lang="ts">
import { UIButton } from '@ui/buttons'
import { ArrowPathIcon } from '@heroicons/vue/24/outline'

type Props = {
  message: string
  hideButton?: boolean
}

type Emits = {
  retry: []
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleClickRetry = () => {
  emit('retry')
}
</script>

<style scoped>
.ui-ai-conversation-error {
  @apply flex items-center justify-center;
  @apply p-4 gap-4;
  @apply rounded-md;
  @apply border border-red-300 dark:border-red-300;
  @apply text-red-500 dark:text-red-300;
  @apply text-base sm:text-sm;

  &__message {
    @apply text-sm sm:text-xs;
  }
}
</style>
